/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Submit_Application_TitleInputs */

const en_confirm_submit_application_title = /** @type {(inputs: Confirm_Submit_Application_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you want to submit your application now?`)
};

const de_confirm_submit_application_title = /** @type {(inputs: Confirm_Submit_Application_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchtest du deine Bewerbung jetzt final einreichen?`)
};

/**
* | output |
* | --- |
* | "Do you want to submit your application now?" |
*
* @param {Confirm_Submit_Application_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const confirm_submit_application_title = /** @type {((inputs?: Confirm_Submit_Application_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Submit_Application_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_confirm_submit_application_title(inputs)
	return en_confirm_submit_application_title(inputs)
});